import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Attachment } from './_interfaces/attachment';
import { AttachmentStatus, ErrorType } from './_enums/Attachment-Status.enum';
import { IDocumentConfiguration } from './_interfaces/DocumentConfiguration';
import { UploadService } from './_services/upload.service';
import { DocumentMode } from './_enums/DocumentMode.enum';
import { DocumentType } from './_enums/DocumentType.enum';
import { IEntityConfiguration } from './_interfaces/IEntityConfiguration';
import { PopupConfirmationComponent } from '../popup-confirmation/popup-confirmation.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { FileHelpers } from './_interfaces/FileHelpers';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-document-uploader',
  templateUrl: './document-uploader.component.html',
  styleUrls: ['./document-uploader.component.css']
})

export class DocumentUploaderComponent implements OnInit, OnChanges {

  isErrorExist: boolean = false;
  message = '';
  fileds = new Array<Attachment>();
  Attachments = new Array<Attachment>();

  // document modes
  newMode: DocumentMode = DocumentMode.new;
  editMode: DocumentMode = DocumentMode.edit;
  readMode: DocumentMode = DocumentMode.read;

  //Document types
  fileType: DocumentType = DocumentType.File;
  urlType: DocumentType = DocumentType.URL;

  incrementalId: number = 1;
  userLang: string;
  confirmModalRef: BsModalRef;

  // Inputs
  @Input() Mode: DocumentMode;
  @Input() DocConfig: IDocumentConfiguration;
  @Input() EntityConfigration: IEntityConfiguration;
  // not a normal case
  @Input() IsMaximumOverride: boolean = false;
  @Input() NumberOfElement: number = 1;

  // Outputs
  @Output() DocumentChanged: EventEmitter<IDocumentConfiguration> = new EventEmitter<IDocumentConfiguration>();
  @Output() StartUploading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() Uploaded: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() URLSaved: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private uploadService: UploadService,
    private translateService: TranslateService,
    private modalService: BsModalService,
  ) {
    this.userLang = this.translateService.currentLang;
    this.DocConfig = { Files: [], DocumentType: {}, DocumentURL:{} };
  }

  ngOnInit() {
    this.prepareFields();


    // if the document in readonly mode, start to over ride current mode value
    if (this.DocConfig.IsReadOnly) {
      this.Mode = this.readMode;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.DocConfig && changes.DocConfig.currentValue
      && changes.DocConfig.currentValue != this.DocConfig) {
      this.DocConfig.Files = changes.DriverToEdit.currentValue['Files'] || [];
      this.DocConfig.DocumentType = changes.DriverToEdit.currentValue['DocumentType'] || {};
      this.DocConfig.DocumentURL = changes.DriverToEdit.currentValue['DocumentURL'] || {};
    }
  }

  // ------------------ load and prepare files -------------------
  prepareFields() {
    if (((this.Mode === DocumentMode.edit || this.Mode === DocumentMode.read) && this.DocConfig.Files !== null)
      || (this.Mode === DocumentMode.new && this.DocConfig.Files !== null && this.DocConfig.Files.length > 0)) {
      this.loadExistingFiles();
      this.CheckIfAllAttachmentUploaded();
    }
  }

  loadExistingFiles() {
    this.fileds = new Array<Attachment>();
    this.incrementalId = 1;

    if (this.Mode === DocumentMode.new && this.DocConfig.Files !== null && this.DocConfig.Files.length > 0) {
      for (let i = 0; i < this.DocConfig.Files.length; i++) {
        const filedTemp: Attachment = {
          id: this.incrementalId.toString(),
          status: isNaN(this.DocConfig.Files[i].Status) ? 
          AttachmentStatus[this.DocConfig.Files[i].Status.toString()] : this.DocConfig.Files[i].Status,
          error: ErrorType.noError,
          title: this.DocConfig.Files[i].FileName,
          isBeningDownloading: false,
          isBeningDeleted: false
        };
        this.fileds.push(filedTemp);
        this.incrementalId++;
      }
    } else {
      for (let i = 0; i < this.DocConfig.Files.length; i++) {
        const filedTemp: Attachment = {
          id: this.incrementalId.toString(),
          status: isNaN(this.DocConfig.Files[i].Status) ?
          AttachmentStatus[this.DocConfig.Files[i].Status.toString()] : this.DocConfig.Files[i].Status,
          error: ErrorType.noError,
          title: this.DocConfig.Files[i].FileName,
          isBeningDownloading: false,
          isBeningDeleted: false
        };
        this.fileds.push(filedTemp);
        this.incrementalId++;
      }
    }
  }

  addAttachmentField(): string {
    const filedTemp: Attachment = {
      id: this.incrementalId.toString(),
      status: AttachmentStatus.empty
    };
    this.fileds.push(filedTemp);
    this.incrementalId++;

    return filedTemp.id;
  }

  CheckIfAllAttachmentUploaded(): boolean {
    for (let i = 0; i < this.fileds.length; i++) {
     if(this.fileds[i].status !== AttachmentStatus.uploaded && this.fileds[i].status !== AttachmentStatus.Temporary) {
      this.DocConfig.isDocConfigUploaded = false;
       return false;
     }
    }
    this.DocConfig.isDocConfigUploaded = true;
    return true;
  }

  // -------------------- attach multiple files -------------------
  attachFile(fileUploaded, url) {
     let id = this.addAttachmentField();
    const file = {
      name: fileUploaded.name,
      lastModified: fileUploaded.lastModifiedDate ?
        fileUploaded.lastModifiedDate.toLocaleDateString() : 'n/a',
      path: url,
      size: fileUploaded.size,
      type: '.' + fileUploaded.name.split('.').pop(),
      detailsType: fileUploaded.type
    };
    this.fileds.filter(f => f.id === id)[0].url = file.path;
    this.fileds.filter(f => f.id === id)[0].title = file.name;
    this.fileds.filter(f => f.id === id)[0].size = this.formatSizeByteToMB(file.size);

    if (this.formatSizeByteToMB(file.size) > this.DocConfig.MaxAttachSize && !this.checkExtention(fileUploaded)) {
      this.fileds.filter(f => f.id === id)[0].status = AttachmentStatus.invalid;
      this.fileds.filter(f => f.id === id)[0].error = ErrorType.multiErrors;
      this.fireErrorCase(this.fileds.filter(f => f.id === id)[0]);
    } else if (!this.checkFilesSize(file.size)) {
      this.fileds.filter(f => f.id === id)[0].status = AttachmentStatus.invalid;
      this.fileds.filter(f => f.id === id)[0].error = ErrorType.maxSizeError;
      this.fireErrorCase(this.fileds.filter(f => f.id === id)[0]);
    } else if (!this.checkExtention(fileUploaded)) {
      this.fileds.filter(f => f.id === id)[0].status = AttachmentStatus.invalid;
      this.fileds.filter(f => f.id === id)[0].error = ErrorType.extensionError;
      this.fireErrorCase(this.fileds.filter(f => f.id === id)[0]);
    } else {
      this.fileds.filter(f => f.id === id)[0].status = AttachmentStatus.valid;
      const AttachTemp: Attachment = {
        id: id,
        title: file.name,
        url: file.path,
        size: this.formatSizeByteToMB(file.size),
        status: AttachmentStatus.valid,
        error: ErrorType.noError,
        file: fileUploaded,
        isBeningDownloading: false,
        isBeningDeleted: false
      };
      this.Attachments.push(AttachTemp);
      this.CheckIfAllAttachmentUploaded();
    }
    this.chackAllFields();
    event.stopPropagation();
  }

  attachFiles(event) {
    if (
    (this.IsMaximumOverride === true && this.DocConfig.MaxNumberOfAttach > 0 && (event.target.files.length + this.fileds.length) > (this.DocConfig.MaxNumberOfAttach * this.NumberOfElement))
      || (this.IsMaximumOverride === false && this.DocConfig.MaxNumberOfAttach > 0 && (event.target.files.length + this.fileds.length) > this.DocConfig.MaxNumberOfAttach)) {
        this.translateService.get('DocumentUploader-container.Messages.NumberOfFiles')
        .subscribe(value => {
          this.fireErrorByMassage(value + this.DocConfig.MaxNumberOfAttach);
        });
    }
    else if (event.target.files.length !== 0) {
      // for (let i = 0; i < event.target.files.length; i++) {
      //   this.attachFile(event.target.files[i], event.target.value);
      // }

      let target = event.target || event.srcElement;
      for (let i = 0; i < target.files.length; i++) {
        this.attachFile(target.files[i], target.value);
      }
      target.value = '';
    }

   
    }

  // ------------------
  chackAllFields() {
    let numberOfErrors = 0;
    for (let i = 0; i < this.fileds.length; i++) {
      if (this.fileds[i].status === AttachmentStatus.invalid) {
        this.fireErrorCase(this.fileds[i]);
        this.fileds.splice(i, 1);
        numberOfErrors++;
      }
    }

    if (numberOfErrors === 0) {
      this.isErrorExist = false;
      this.message = '';
    } else if (numberOfErrors > 1) {
      this.fireErrorByMassage('There is an error, Cheak all attachments')

    }
  }
  chackAllAttachmentsValid(): boolean {
    let numberOfErrors = 0;
    for (const index in this.Attachments) {
      if (this.Attachments[index].status !== AttachmentStatus.valid) {
        this.fireErrorCase(this.Attachments[index]);
        numberOfErrors++;
      }
    }
    if (numberOfErrors === 0) {
      this.message = '';
      return true;
    } else if (numberOfErrors > 1) {
      this.fireErrorByMassage('There is an error, Cheak all attachments')
      return false;
    }
  }
  fireErrorCase(attach: Attachment) {
    this.isErrorExist = true;
    if (attach.status === AttachmentStatus.empty) {
      this.message = 'Attch a file in empty field';
    } else if (attach.error === ErrorType.maxSizeError) {
      let mb = '';
      this.translateService.get('DocumentUploader-container.Labels.MB')
      .subscribe(value => mb = value);
      this.translateService.get('DocumentUploader-container.Messages.FileSizeError')
        .subscribe(value => this.fireErrorByMassage(value + this.DocConfig.MaxAttachSize + mb));
    } else if (attach.error === ErrorType.extensionError) {
      let file = '';
      this.translateService.get('DocumentUploader-container.Labels.File')
      .subscribe(value => file = value);
      this.translateService.get('DocumentUploader-container.Messages.FileTypeError')
        .subscribe(value => this.fireErrorByMassage(this.userLang === 'en'? (value + " '" + this.DocConfig.AllowedExtensions + "' " + file):(value + " "+file+ " '" + this.DocConfig.AllowedExtensions + "'")));
    } else if (attach.error === ErrorType.multiErrors) {
      this.translateService.get('DocumentUploader-container.Messages.FileSizeError')
        .subscribe(value => this.message = value + this.DocConfig.MaxAttachSize);
      this.translateService.get('DocumentUploader-container.Messages.FileTypeError')
        .subscribe(value => this.message += value + this.DocConfig.AllowedExtensions);
    } else {
      this.message = 'There is an error, Cheak all attachments';
    }
  }
  fireErrorByMassage(errorMessage: string) {
    this.message = errorMessage;
    this.isErrorExist = true;
  }
  ShowTranslatedMassage(translationCode: string) {
    this.translateService.get(translationCode)
      .subscribe(value => this.message = value);
    this.isErrorExist = true;
  }

  // ------------------ delete file - remove attachmen ----------------
  delete(attachment: Attachment) {
    let confirmationMassage = ''; let yesBtnName = 'Yes';  let noBtnName: "No";
    this.translateService.get("Common-container.Alert.ConfirmationMassage").subscribe(value => {
      confirmationMassage = value;
    });
    this.translateService.get("Common-container.Alert.YesBtnName").subscribe(value => {
      yesBtnName = value;
    });
    this.translateService.get("Common-container.Alert.NoBtnName").subscribe(value => {
      noBtnName = value;
    });
    
    const initialState = {
      confirmationMassage: confirmationMassage,
      yesBtnName: yesBtnName,
      noBtnName: noBtnName
    };

    this.confirmModalRef = this.modalService.show(
      PopupConfirmationComponent,
      { initialState }
    );
    this.confirmModalRef.content.onClose.subscribe(result => {
      if (result) {
        attachment.isBeningDeleted = true;
        if (attachment.status === AttachmentStatus.uploaded) {
          this.deleteFile(attachment.id);
        } else {
          this.removeFileFromLists(attachment.id);
        }
      }  
    }) 
  }
  removeFileFromLists(fileId: string){
    // --------- remove it from document config ------------
    if (this.DocConfig.Files !== null) {
      let IndexOfFile = -1;
      IndexOfFile = this.DocConfig.Files.indexOf(
        this.DocConfig.Files.filter(f => f.FileName === this.fileds.filter(a => a.id === fileId)[0].title)[0]
        );
        if (IndexOfFile !== -1) {
          this.DocConfig.Files.splice(IndexOfFile, 1);
        }
      }
    // -------------- remove it from attachment ----------------
    if (this.Attachments !== null) {
      let IndexOfAttachment = -1;
      IndexOfAttachment = this.Attachments.indexOf(
        this.Attachments.filter(a => a.id === fileId)[0]
        );
        if (IndexOfAttachment !== -1) {
          this.Attachments.splice(IndexOfAttachment, 1);
        }
      }
    // --------------- remove it from fields --------------------
    if (this.fileds !== null) {
      let IndexOfField = -1;
      IndexOfField = this.fileds.indexOf(
        this.fileds.filter(a => a.id === fileId)[0]
        );
        if (IndexOfField !== -1) {
          this.fileds.splice(IndexOfField, 1);
        }
      }
  }

  //#region [file checks & validations]
  formatSizeByteToMB(bytes): number {
    const size = (bytes / 1048576).toFixed(2);
    return Number(size);
  }
  checkFilesSize(size): boolean {
    return this.formatSizeByteToMB(size) <= this.DocConfig.MaxAttachSize;
  }
  // -------------------
  checkFilesNumber(): boolean {
    let isNumberOfAttachmentsValid: boolean = true;
    isNumberOfAttachmentsValid = isNumberOfAttachmentsValid === true
    ? this.checkFilesMaxNumber() : true;
    isNumberOfAttachmentsValid = isNumberOfAttachmentsValid === true
    ? this.checkFilesMinNumber() : true;
    return isNumberOfAttachmentsValid;
  }
  checkFilesMaxNumber(): boolean {
    if(this.DocConfig.MaxNumberOfAttach != undefined && this.DocConfig.MaxNumberOfAttach > 0)
    {
      if (this.IsMaximumOverride) {
        return this.fileds.length <= (this.DocConfig.MaxNumberOfAttach * this.NumberOfElement)
      ? true : false;
      } else {
        return this.fileds.length <= this.DocConfig.MaxNumberOfAttach 
        ? true : false;
      }
    } else {
      return true;
    }
  }
  checkFilesMinNumber(): boolean {
    if (this.IsMaximumOverride) {
      return this.fileds.length >= (this.DocConfig.MinNumberOfAttach * this.NumberOfElement)
    ? true : false;
    } else {
      return this.fileds.length >= this.DocConfig.MinNumberOfAttach 
    ? true : false;
    }
  }
  // ---------------------
  checkFilesExtention(): boolean {
    for (let i = 0; i < this.Attachments.length; i++) {
      if (!this.checkExtention(this.Attachments[i].file)) {
        return false;
      }
    }
    return true;
  }
  checkExtention(file: File): boolean {
    let extensionArray = this.DocConfig.AllowedExtensions.split(',');

      let isFileExtentionAllowed = false

      for (let i = 0; i < extensionArray.length; i++) {
        if (file.type === FileHelpers.types[extensionArray[i].replace('.', '')])
          isFileExtentionAllowed = true;
      }

      return isFileExtentionAllowed;
  }
//#endregion


//#region [Html appearance]
  showUploadButton() {
    if (this.checkFilesMinNumber() && this.DocConfig.isDocConfigUploaded !== true && this.fileds.length !== 0) {
      return true;
    } else {
      return false;
    }
  }

  disabledUploadButton(){
    if (this.DocConfig.isDocConfigUploading === true && this.DocConfig.isDocConfigUploaded !== true) {
      return true;
    } else {
      return false;
    }
  }

  disabledAddFileButton() {
    if ((this.DocConfig.isDocConfigUploading === true && this.DocConfig.isDocConfigUploaded !== true) 
    || !this.checkFilesMaxNumber() 
    || (this.fileds.length === (this.DocConfig.MaxNumberOfAttach * this.NumberOfElement) && this.DocConfig.MaxNumberOfAttach > 0) ){
      return true;
    } else {
      return false;
    }
  }

  showNumberOfAttachmentDetails(): boolean{
    if ( 
      ((this.DocConfig.MaxNumberOfAttach > 0 && this.DocConfig.MinNumberOfAttach > 0) && !this.IsMaximumOverride)
    || ((this.DocConfig.MaxNumberOfAttach * this.NumberOfElement > 0 || this.DocConfig.MinNumberOfAttach * this.NumberOfElement > 0) && this.IsMaximumOverride))  
      return true;
    else
      return false;
  }
//#endregion


//#region [Requests]
  // ---------------------- upload temp file --------------------------
  uploadAttachments() {
    this.DocConfig.NumberOfElement = this.IsMaximumOverride === true
      ? this.NumberOfElement : 0;

    this.DocConfig.isDocConfigUploading = true;
    this.StartUploading.emit(true);

    let isAttachmentsValid: boolean = true;
    isAttachmentsValid = isAttachmentsValid === true
      ? this.checkFilesNumber() : true;
    isAttachmentsValid = isAttachmentsValid === true
      ? this.checkFilesExtention() : true;
    // isAttachmentsValid = isAttachmentsValid === true
    // ? this.checkFilesSize() : true;

    isAttachmentsValid = this.chackAllAttachmentsValid();

if (isAttachmentsValid) {
  this.uploadService.uploadFilesToTheTemp(this.DocConfig, this.Attachments).subscribe(
    response => {
      if (response['Status'] === 'Success') {
        if (response['Result'] !== null) {
          this.DocConfig = response['Result']
          this.DocConfig.isDocConfigUploaded = true;
          this.Uploaded.emit(true);
          this.StartUploading.emit(false);
          this.DocumentChanged.emit(this.DocConfig);
          this.prepareFields();
        } else {
          console.error(response['Message'] !== null ? response['Message'] : 'error');
          this.DocConfig.isDocConfigUploaded = false;
          this.DocConfig.isDocConfigUploading = false;
          this.Uploaded.emit(false);
          this.StartUploading.emit(false);
        }
      } else {
        alert(response['Message']);
        this.DocConfig.isDocConfigUploaded = false;
        this.DocConfig.isDocConfigUploading = false;
        this.Uploaded.emit(false);
        this.StartUploading.emit(false);
      }
    } , err=> {
      alert(err);
    }
    );
  }
  }
// --------------------- delete & download File ---------------
  downloadFile(filedId){
    // change starting download flage
    this.fileds.filter(a => a.id === filedId)[0].isBeningDownloading = true;

    this.uploadService.GetFile(
      this.DocConfig,
      this.DocConfig.Origin.Value.toString(),
      this.fileds.filter(a => a.id === filedId)[0].title,
      this.EntityConfigration.EntityLogicalName,
      this.EntityConfigration.RequestNumber,
      this.EntityConfigration.requestId
    ).subscribe(
      response => {
          this.fileds.filter(a => a.id === filedId)[0].isBeningDownloading = false;
          if (response['Status'] === 'Success') {
            this.uploadService.downloadFile(this.fileds.filter(a => a.id === filedId)[0].title, response['Result']);
          } else {
            console.log(response['Message']);
          }
        },

    err=> console.log(err)
    );
  }
  deleteFile(filedId){
        this.uploadService.DeleteFile(
          this.DocConfig,
          this.DocConfig.Origin.Value.toString(),
          this.fileds.filter(a => a.id === filedId)[0].title,
          this.EntityConfigration.EntityLogicalName ,
          this.EntityConfigration.RequestNumber,
          this.EntityConfigration.requestId,
          this.DocConfig.Origin.Value === 2 || this.DocConfig.RequestDocument !== null
          ? this.DocConfig.RequestDocument.DocumentLocation['Id'] : '',
        ).subscribe(
          response => {
            if (response['Status'] === 'Success') {
              if (response['Result'] === true) {
                this.removeFileFromLists(filedId);
              }
              else{
                console.log(response['Message']);
              }
            }
        },
          err=> console.log(err)
        );
  }
//#endregion


saveUrl(inputElement){  
  if (inputElement && inputElement['value']) {
    this.DocConfig.DocumentURL = {
      URL: inputElement['value'],
      Status: AttachmentStatus.uploaded
    }
    inputElement['value']="";

    this.Uploaded.emit(true);
    this.URLSaved.emit(true);
    this.DocConfig.isDocConfigUploaded = true;
    this.DocumentChanged.emit(this.DocConfig);
  }
}
// updateUrl(inputElement){  
//   console.log('sdssss', inputElement);
  
//   if (inputElement && this.DocConfig 
//     && this.DocConfig.DocumentURL && this.DocConfig.DocumentURL.URL) {
//     inputElement['value'] = this.DocConfig.DocumentURL.URL;
//   }
// }
deleteUrl(){
  if (this.DocConfig && this.DocConfig.DocumentURL && this.DocConfig.DocumentURL.URL) {
    this.DocConfig.DocumentURL = {
      URL: "",
      Status: AttachmentStatus.empty
    }

    this.URLSaved.emit(false);
    this.DocumentChanged.emit(this.DocConfig);
  }
}
disableAddUrl(): boolean{
  if ((this.DocConfig.DocumentURL
    && this.DocConfig.DocumentURL.URL
    && this.DocConfig.DocumentURL.URL !== "")
    || this.disabledAddFileButton()) {
    return true;
  } else {
    return false;
  }
}



}